import {AUTH_LOGOUT, USER_ERROR, USER_REQUEST, USER_SUCCESS} from '@/store/mutation-types'
import Vue from 'vue'

const state = {
	status: '',
	profile: {}
}

const getters = {
	getProfile: state => state.profile,
	isProfileLoaded: state => !!state.profile.name,
}

const actions = {
	[USER_REQUEST]: ({commit, dispatch}) => {
		commit(USER_REQUEST)
		apiCall({url: 'user/me'}) // todo use api service here
			.then(resp => {
				commit(USER_SUCCESS, resp)
			})
			.catch(resp => {
				commit(USER_ERROR)
				dispatch(AUTH_LOGOUT)
			})
	}
}

const mutations = {
	[USER_REQUEST]: (state) => {
		state.status = 'loading'
	},
	[USER_SUCCESS]: (state, resp) => {
		state.status = 'success'
		Vue.set(state, 'profile', resp)
	},
	[USER_ERROR]: (state) => {
		state.status = 'error'
	},
	[AUTH_LOGOUT]: (state) => {
		state.profile = {}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js